import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DeliveryChannelPreferences } from 'src/app/shared/models/MFAPreferencesResponse';
import { PinRequest } from 'src/app/shared/services/mfa-pin/APIResponse';
import { MfaPinService } from 'src/app/shared/services/mfa-pin/mfa-pin.service';
import { GdlService } from 'src/app/shared/services/gdl-service/gdl.service';

export interface ChannelEvent {
  channel: DeliveryChannelPreferences;
  showDiffMethodLinkStatus: boolean;
}

@Component({
  selector: 'wpro-verification-method',
  templateUrl: './verification-method.component.html',
  styleUrls: ['./verification-method.component.css'],
  standalone: false
})
export class VerificationMethodComponent {
  _channels?: DeliveryChannelPreferences[] | null;
  _method = '';
  isLoadingState = true;

  @Output() channel = new EventEmitter<ChannelEvent>();
  @Output() apiError = new EventEmitter<boolean>();

  @Input() get channels(): DeliveryChannelPreferences[] | null | undefined {
    return this._channels ?? [];
  }

  constructor(private sendPinService: MfaPinService,
              private gdlService: GdlService) {}

  set channels(channels: DeliveryChannelPreferences[] | null | undefined) {
    this._channels = channels;
    this.isLoadingState = this._channels ? false : true;
  }

  methodSelected(channel: string): void {
    this._method = channel;
  }

  sendPin(): void {
    const output: ChannelEvent = {
      channel: this.channels.find(channel => channel.deliveryMethod === this._method),
      showDiffMethodLinkStatus: this.channels.length > 1
    };

    const pinRequest: PinRequest = {
      deliveryMethod: this._method,
      preferredDeliveryType: (this._method === 'EMAIL') ? 'PERSONALEMAIL' : 'PHONE'
    };

    this.gdlService.triggerGdlLogEvent('modal', 'confirm',
      {
        name: this._method === 'SMS' ? 'wpro-loginsecurity-2fa-verifyidentity-text'
           : this._method === 'EMAIL' ? 'wpro-loginsecurity-2fa-verifyidentity-email'
           : 'wpro-loginsecurity-2fa-verifyidentity-phonecall'
      }
    );

    this.sendPinService.requestPin(pinRequest).subscribe(() => {
      this.channel.next(output);
    }, () => {
      this.channel.next(output);
    });

  }
}
